import {
    getMpxAllAssetsApi,
    getMpxCastCrewApi,
    getSeasonsApi,
    getEpisodesApi,
} from '../services/serviceWrapper/mpxServiceWrapper';
import { getCountry } from '../helpers/common';

const mpx = {
    getSeasons: (bySeriesId, byCustomValue) => {
        return getSeasonsApi(bySeriesId, byCustomValue);
        // return apis.getMpxService().seasons().getSeasons(bySeriesId, byCustomValue);
    },
    getEpisodes: (byTvSeasonId) => {
        return getEpisodesApi(byTvSeasonId);
        // return apis.getMpxService().seasons().getEpisodes(byTvSeasonId);
    },
    getItemFeed: async (byId) => {
        return getMpxAllAssetsApi({ byId, byCustomValue: `{PC}{${getCountry()}}` });
        // return apis.getMpxService().vodDetails().getItemFeed(byId);
    },
    getCastCrew: async (byId) => {
        return getMpxCastCrewApi(byId);
        // return apis.getMpxService().castCrew().getCastCrew(byId);
    },
    getMovieDetail: (byId) => {
        return getMpxAllAssetsApi({ byId, range: '0-12' });
        // return apis.getMpxService().vodDetails().getMovieDetail(byId);
    },
    getSeriesDetail: (byGuid) => {
        return getMpxAllAssetsApi({ byGUID: byGuid, range: '0-12' });
        // return apis.getMpxService().vodDetails().getSeriesDetail(byGuid);
    },
};

export default mpx;
